import React from 'react';
import personAtComputer from '../../assets/DDHAPPS/white-top-price.webp';
import PageHero from '../../components/shared/PageHero';

const s = {
  heroBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 10,
    background: '#fff',
    border: '1px solid #e5e5ea',
    borderRadius: 32,
    padding: '10px 20px',
    fontSize: 'clamp(0.72rem, 2vw, 0.82rem)',
    color: '#6b6b6b',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    maxWidth: 560,
    textAlign: 'left',
  },
  heroBadgeDot: {
    width: 7,
    height: 7,
    borderRadius: '50%',
    background: '#34d399',
    flexShrink: 0,
  },
  link: {
    color: '#4338ca',
    fontWeight: 600,
    textDecoration: 'none',
  },
};

const badge = (
  <div style={s.heroBadge}>
    <span style={s.heroBadgeDot} />
    Any questions about pricing? <a href="/contact" style={s.link}>We're happy to help.</a>
  </div>
);

function PricingHero() {
  return (
    <PageHero
      eyebrow="Pricing"
      headline={<>Simple,<br />honest pricing.</>}
      image={personAtComputer}
      sub="No hidden costs. You own your domain and app accounts. We provide the expertise, the code, and the ongoing care."
      badge={badge}
    />
  );
}

export default PricingHero;
